<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>
    <div class="mobileHeader">
      <p>
        <span>签收单号：{{ list.putOnNo }}</span>
      </p>
      <p>
        <span>到仓日期：{{ list.signTime }}</span>
      </p>
      <p>
        <span>SKU：{{ list.skuCode }}</span
        ><span
          >上架件数：{{ list.boxCount }}/<span class="red">{{
            list.actualBoxCount
          }}</span></span
        >
      </p>
      <p>
        <span
          >上架数量：{{ list.qty }}/<span class="red">{{
            list.actualPutOnQty
          }}</span></span
        ><span>签收人：{{ list.signUser }}</span>
      </p>
    </div>

    <div class="putC_container">
      <div class="putC_search">
        <span>请输入件数</span>
        <div>
          <van-field
            size="small"
            v-model="search.boxCount"
            placeholder="件数"
            @change="inputNumChange('boxCount')"
            @focus="boxCountFocus"
            ref="boxCount"
          />
        </div>
      </div>
      <div class="putC_search isContainTail">
        <van-checkbox
          v-model="search.isContainTail"
          :disabled="containTailDisabled"
          shape="square"
          >包含尾箱</van-checkbox
        >
      </div>
      <div class="putC_search">
        <span>请输入库位</span>
        <div>
          <van-field
            size="small"
            v-model="search.storageName"
            placeholder="库位"
            right-icon="scan"
            @click-right-icon="scan"
            @focus="storageFocus"
            @input="storageChange"
            ref="storage"
          />
        </div>
      </div>
    </div>

    <div class="putC_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="boxCount"
          label="总收货件数"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="actualBoxCount"
          label="已上架件数"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="lastBoxCount"
          label="待上架件数"
          min-width="100"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <div class="putC_footer">
      <button class="submit-btn" @click="submit">确认上架</button>
      <button class="submit-btn confirm-btn" @click="showForceComplete">
        强制完成
      </button>
    </div>

    <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Tab,
  Tabs,
  NoticeBar,
  Dialog,
  Toast,
  Checkbox,
} from "vant";
import {
  getPutOnBox,
  submitPutOnDetail,
  overPutOn,
} from "@/api/mobile/putaway_api";
import { getWarehouseLocation } from "@/api/mobile/stock_api";
import util from "util/date";
import { mapState } from "vuex";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      submitData: {},
      active: 0,
      showPicker: false,
      search: {},
      saveSrcArr: [],
      tableData: [
        {
          boxCount: "0",
          actualBoxCount: "0",
          lastBoxCount: "0",
        },
      ],
      list: {},
      columns: [],
      containTailDisabled: false,
      loading: false,
      viewportHeight: 0,
      focusType: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },
  methods: {
    init() {
      const that = this;
      this.getPutOnBox();

      // 处理键盘弹起顶起下拉框遮挡输入框问题
      this.viewportHeight = window.innerHeight;
      window.addEventListener(
        "resize",
        function () {
          if (that.viewportHeight - this.innerHeight > 50) {
            // 键盘弹起
            if (that.focusType === "storageName") {
              that.showPicker = false;
            }
            const activeElement = document.activeElement;
            if (
              activeElement.tagName === "INPUT" ||
              activeElement.tagName === "TEXTAREA"
            ) {
              that.$nextTick(function () {
                that.$refs.storage.focus
                  ? (that.$refs.storage.scrollTop = 100)
                  : (that.$refs.boxCount.scrollTop = 100);
              });
            }
          } else {
            // 键盘收起
            if (that.focusType === "storageName") {
              that.showPicker = true;
            }
          }
        },
        true
      );
    },
    scan() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "storageName", a.resultStr);
        },
      });
    },
    boxCountFocus() {
      this.focusType = "boxCount";
      this.showPicker = false;
    },
    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "storageName";
      this.storageChange();
    },

    storageChange() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;

      const { storageName } = this.search;
      const { warehouseId } = _warehouse;

      if (!storageName) return;

      const data = { locationCode: storageName, warehouseId };
      this.loading = true;

      getWarehouseLocation(data).then((res) => {
        this.loading = false;
        if (res.status === 200) {
          const { response } = res;

          try {
            let arr = [];
            response.forEach((item) => {
              arr.push(item.locationCode);
            });
            this.columns = arr;
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onConfirm(val) {
      this.$set(this.search, "storageName", val);
      this.showPicker = false;
    },
    getPutOnBox() {
      const { boxInfoID } = this.$route.query;
      const data = { boxInfoID };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getPutOnBox(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.signTime = util.formatDate.format(
              new Date(response.signTime),
              "yyyy-MM-dd"
            );

            this.list = response;

            const { boxCount, actualBoxCount, lastBoxCount, tailBoxPcsQty } =
              response;
            this.tableData = [
              {
                boxCount,
                actualBoxCount,
                lastBoxCount,
              },
            ];

            if (!tailBoxPcsQty) {
              this.containTailDisabled = true;
            }
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },
     showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const { boxInfoID } = this.$route.query;
      const {
        productID,
        skuCode,
        warehouseID,
        tailBoxPcsQty,
        boxCount,
        sourceTypeID,
      } = this.list;

      const data = {
        productID,
        skuCode,
        warehouseID,
        putStockBoxInfoID: boxInfoID,
        sourceTypeID,
        ...this.search,
      };

      ///佰易其他入库
      if (Number(sourceTypeID) == 3) {
        if (Number(tailBoxPcsQty) > 0) {
          if (!this.search.isContainTail) {
             this.showsound(false);
            Toast("该上架单只有一个尾箱,请选择包含尾箱");
            return;
          }
        }

        if (Number(boxCount) != Number(this.search.boxCount)) {
           this.showsound(false);
          Toast("佰易其他入库不支持部分上架,件数必须相等");
          return;
        }
      }

      if (!this.checkSearch()) {
        return;
      }

      Toast.loading({
        message: "上架中...",
        forbidClick: true,
      });

      submitPutOnDetail(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.getPutOnBox();
           this.showsound(true);
          Toast.success("上架成功");

          //debugger;
          //that.$router.push({path:'/mobile/putaway',query:{skuCode:''}})

          setTimeout(function () {
            that.$router.go(-2);
          }, 1500);
        } else {
           this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
    showForceComplete() {
      const {
        skuCode,
        productNameCN,
        putOnNo,
        relationNumber,
        qty,
        boxCount,
        actualPutOnQty,
        actualBoxCount,
        tailBoxPcsQty,
        sourceTypeID,
      } = this.list;

      ///佰易其他入库
      if (Number(sourceTypeID) == 3) {
        this.showsound(false);
        Toast("佰易其他入库单不允许强制完成");
        return;
      }
      Dialog.confirm({
        title: "上架强制完成",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        messageAlign: "left",
        message: `SKU：${skuCode} (${productNameCN})\n入库单号：${putOnNo}\n采购单号：${relationNumber}\n收货数量：${qty}\n收货箱数：${boxCount}\n已上架数量：${actualPutOnQty}\n已上架箱数：${actualBoxCount}\n<p style="color:red;">请确认是否强制完成,此操作不可逆。</p>`,
      })
        .then(() => {
          this.forceComplete();
        })
        .catch(() => {});
    },
    forceComplete() {
      const that = this;
      const { boxInfoID } = this.$route.query;

      const data = { putStockBoxInfoID: Number(boxInfoID) };

      Toast.loading({
        message: "强制上架中...",
        forbidClick: true,
      });

      overPutOn(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.getPutOnBox();
          Toast.success("强制入库上架完成");

          // that.$router.push({path:'/mobile/putaway',query:{skuCode:'ddd'}})

          setTimeout(function () {
            that.$router.go(-2);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    checkSearch() {
      const { boxCount, storageName, isContainTail } = this.search;
      if (!boxCount) {
         this.showsound(false);
        Toast("请输入件数");
        return false;
      }
      if (Number(boxCount) === 0) {
         this.showsound(false);
        Toast("件数不能为零，请重新输入");
        return false;
      }
      if (!storageName) {
         this.showsound(false);
        Toast("请输入库位");
        return false;
      }
      if (
        isContainTail &&
        boxCount ===
          Number(this.list.boxCount) - Number(this.list.actualBoxCount)
      ) {
         this.showsound(false);
        Toast("操作失败，本次上架箱数大于已签收箱数");
        return false;
      }
      return true;
    },
    inputNumChange(field) {
      let num = Number(this.search[field]);
      const c = Number(this.list.boxCount) - Number(this.list.actualBoxCount);
      if (num > c) {
         this.showsound(false);
        Toast(`最大可输入件数为可收货件数`);
        num = c;
      } else if (num < 0) {
         this.showsound(false);
        Toast("请输入正数");
        num = Math.abs(num) > c ? c : Math.abs(num);
      }
      this.$set(this.search, field, parseInt(num));
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  p {
    margin: 5px 0;
    display: flex;
    span {
      flex: 1;
      word-break: break-all;
    }
  }
}
::v-deep .van-tabs__line {
  background-color: #29c727;
}
.sign-item {
  background-color: #fbf9fe;
  padding: 10px;
  .signInDetail-content {
    font-size: 15px;
  }
  .signInDetail-btnBox {
    li {
      line-height: 40px;
    }
    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
    }
  }
}
.submit-btn {
  width: 49%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 15px;
  border: 0;
}
.confirm-btn {
  background-color: #ff0000;
  float: right;
}
.hidden {
  display: none;
}
::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .van-notice-bar {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.putC_container {
  padding: 5px 10px;
  .putC_search {
    display: flex;
    line-height: 35px;
    > span {
      flex: 0.25;
      font-size: 15px;
      font-weight: 600;
      padding-right: 3%;
      text-align: right;
    }
    > div {
      flex: 0.75;
    }
  }
}
.putC_table {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
}
.putC_footer {
  margin-top: 36%;
  padding: 0 3%;
}
.red {
  color: red;
}
.mr10 {
  margin-right: 10%;
}
.putC_container .isContainTail > div {
  flex: 1;
  justify-content: flex-end;
  margin-bottom: 8px;
}
@media screen and (max-width: 320px) {
  .putC_container {
    .putC_search {
      > span {
        font-size: 12px;
      }
    }
  }
  .mobileHeader {
    span {
      font-size: 12px;
    }
  }
}
</style>